import { Component, inject, Input } from '@angular/core';
import { LibraryGroup } from '../../models/chat-library.models';
import { GroupHeaderComponent } from '../group-header/group-header.component';
import { GroupContentComponent } from '../group-content/group-content.component';
import { CreativeCardGridComponent } from '../creative-card-grid/creative-card-grid.component';
import { ChatLibraryService } from '../../services/chat-library.service';

@Component({
  selector: 'app-library-group',
  standalone: true,
  imports: [GroupHeaderComponent, GroupContentComponent, CreativeCardGridComponent],
  templateUrl: './library-group.component.html',
  styleUrl: './library-group.component.scss',
})
export class LibraryGroupComponent {
  @Input({ required: true }) group!: LibraryGroup;

  private readonly chatLibraryService = inject(ChatLibraryService);

  onFindInChat(): void {
    this.chatLibraryService.focusOnGroup(this.group);
  }
}
